<style scoped>
.max-devices {
  background-color: #b94a48;
  color: white;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}
</style>

<template>
  <v-app class="bgImage">
    <navbar>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">Select Devices</span>
        <span class="font-weight-medium">To Compare</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </navbar>

    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <v-card>
          <m-errorbox ref="errorBox"></m-errorbox>

          <v-card-text>
            <form @submit.prevent="onSearchClick">
              <v-row>
                <v-col>
                  <v-row>
                    <v-col md="6" lg="3">
                      <v-text-field
                        v-model="search"
                        label="Text Search"
                        single-line
                        hide-details
                        clearable
                        prepend-icon="mdi-text-box-search"
                        @click:clear="onSearchClear"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-btn
                        outlined
                        color="primary"
                        type="submit"
                        class="mt-auto"
                      >
                        Search
                        <v-icon right>mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row align="end" justify="start">
                    <v-col md="6" lg="3">
                      <h-autocomplete
                        :model="addressModel"
                        label="Address Search"
                        prepend-icon="mdi-map-search"
                      ></h-autocomplete>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </form>

            <v-row>
              <v-col>
                <h3 class="text-center text-uppercase">
                  Available Devices
                </h3>
                <v-data-table
                  :headers="collection.meta.headers"
                  :items="collection.data"
                  :loading="collection.loading"
                  :options="dataTableOptions"
                  :footer-props="{
                    itemsPerPageOptions: [10, 15, 30, 50, 100]
                  }"
                  hide-default-footer
                >
                  <template v-slot:item.id="{ item }">
                    <v-btn
                      v-if="
                        selectedDevices.find(
                          device => device.device_token == item.device_token
                        )
                      "
                      @click="() => onRemoveDevice(item.device_token)"
                    >
                      <v-icon left>mdi-minus</v-icon>
                      Remove
                    </v-btn>
                    <v-btn
                      v-else
                      @click="() => onAddDevice(item.device_token)"
                      :disabled="selectedDevices.length >= 12"
                    >
                      <v-icon left>mdi-plus</v-icon>
                      Add
                    </v-btn>
                  </template>
                </v-data-table>
                <my-pagination
                  :meta="collection.meta"
                  @request-page="onPaginationRequest"
                />
              </v-col>

              <v-col>
                <h3 class="text-center text-uppercase">
                  Selected Devices
                </h3>
                <v-data-table
                  :headers="collection.meta.headers"
                  :items="selectedDevices"
                  page-sync="1"
                  :items-per-page.sync="selectedDevices.length"
                  :footer-props="{
                    itemsPerPageOptions: []
                  }"
                >
                  <template v-slot:item.id="{ item }">
                    <v-btn @click="() => onRemoveDevice(item.device_token)">
                      <v-icon left>mdi-minus</v-icon>
                      Remove
                    </v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row align="top" justify="end">
              <v-col v-if="selectedDevices.length >= 12" class="pl-4">
                <h2 class="max-devices">
                  Maximum devices reached
                </h2>
              </v-col>

              <v-col md="auto" class="pt-4">
                Channel to Compare:
              </v-col>
              <v-col md="auto" style="padding-top: 5px;">
                <v-select
                  :items="graphLineOptions"
                  v-model="selectedGraphLine"
                  label="Comparision Channel"
                  item-value="key"
                  item-text="value"
                  name="graphLine"
                  solo
                ></v-select>
              </v-col>
              <v-col md="auto">
                <v-btn
                  outlined
                  class="mt-auto mr-6"
                  :disabled="selectedDevices.length == 0"
                  @click="generateGraph"
                >
                  Generate Graph
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import apiRequest from "../mixins/api-request";
import apiEndpoints from "../mixins/api-endpoints";
import MyPagination from "../components/MyPagination.vue";

export default {
  components: {
    MyPagination
  },
  mixins: [apiRequest, apiEndpoints],
  data() {
    return {
      collection: {
        data: [],
        meta: {
          current_page: this.$route.query.page || "1",
          last_page: 1,
          headers: [],
          per_page: this.$route.query.per_page || "10",
          total: 0
        },
        loading: true
      },
      search: "",
      selectedDevices: [],
      selectedGraphLine: "CLI",
      graphLineOptions: [
        { key: "CLI", value: "CLI" },
        { key: "CNI", value: "CNI" }
      ],
      addressModel: {
        values: {}
      },
      validationRules: {
        search_term: model => [
          v =>
            !v ||
            v.length <= 255 ||
            "Search term must be less than 256 characters"
        ]
      }
    };
  },
  mounted() {
    this.performRequest();
    // Clear the selected devices list when the page is mounted
    this.selectedDevices = [];
  },
  computed: {
    dataTableOptions() {
      return {
        page: Number(this.collection.meta.current_page),
        itemsPerPage: Number(this.collection.meta.per_page)
      };
    }
  },
  created() {},
  watch: {
    "$route.query": {
      deep: true,
      handler(value) {
        this.performRequest();
      }
    }
  },
  methods: {
    showError(message) {
      this.$refs.errorBox.showError(message);
    },
    onSearchClear() {
      this.search = "";
      this.routeToPageNumber();
    },
    onAddDevice(value) {
      // Handle adding the device to the list of to devices that will be used in the graph
      const device = this.collection.data.find(d => d.device_token === value);
      const selectedDevice = this.selectedDevices.find(
        d => d.device_token === value
      );
      // Maximum of 12 devices can be selected at a time
      if (device && this.selectedDevices.length < 12) {
        if (selectedDevice) {
          this.selectedDevices.splice(
            this.selectedDevices.indexOf(selectedDevice),
            1
          );
        } else {
          this.selectedDevices.push(device);
        }
      }
    },
    onRemoveDevice(value) {
      this.selectedDevices = this.selectedDevices.filter(
        d => d.device_token !== value
      );
    },
    onSearchClick() {
      this.routeToPageNumber();
    },
    onSearchSuccess(results) {},
    onPaginationRequest({ page, itemsPerPage }) {
      this.routeToPageNumber(page, itemsPerPage);
    },
    routeToPageNumber(pageNumber, itemsPerPage) {
      var queryParams = {
        per_page: itemsPerPage || this.$route.query.per_page || 10,
        page: pageNumber || 1
      };

      if (this.search) {
        queryParams.search_term = this.search;
      }

      if (
        this.addressModel.values.latitude &&
        this.addressModel.values.longitude
      ) {
        queryParams.latitude = this.addressModel.values.latitude;
        queryParams.longitude = this.addressModel.values.longitude;
      } else {
        // No address provided, so clear the query parameters
        delete queryParams.latitude;
        delete queryParams.longitude;
      }

      this.$router.replace({ query: queryParams }).catch(err => {
        // navigation duplicated errors are normal
        // here, and should not be reported to the console.
        if (err.name != "NavigationDuplicated") {
          console.error(err);
        }
      });
    },
    prepareModel(device) {
      // {
      //   "id": 16,
      //   "device_token": "00000000da6383bc",
      //   "device_name": null,
      //   "address": null,
      //   "city": null,
      //   "state": null,
      //   "postcode": null,
      //   "comments": null,
      //   "last_contact": "1731998039",
      //   "online": false,
      //   "first_reading": 1731997448,
      //   "last_reading": 1731997747,
      //   "group_id": 2,
      //   "remote_shell": false,
      //   "group_name": "Huntsman Trial Group",
      //   "nearby": []
      // }
      delete device.city;
      delete device.address;
      delete device.state;
      delete device.postcode;
      delete device.comments;
      delete device.last_contact;
      delete device.online;
      delete device.first_reading;
      delete device.last_reading;
      delete device.group_id;
      delete device.remote_shell;
      delete device.group_name;
      delete device.nearby;
    },
    performRequest() {
      this.collection.loading = true;
      var queryParams = Object.assign({}, this.$route.query);
      let endpoint = this.apiEndpoints.devices;

      this.apiRequest(endpoint, null, queryParams)
        .then(r => {
          if (this.statusOk(r.status)) {
            Vue.set(this, "collection", r.body);
            this.collection.meta.headers = [
              { text: "Add / Remove", value: "id" },
              { text: "Device Info", value: "device_token" },
              { text: "Site Name", value: "device_name" }
            ];
            this.collection.data.forEach(value => this.prepareModel(value));
          } else {
            this.showError("Error fetching data from server");
            console.error(
              "Error fetching data from server: ",
              r.body.message ||
                `No Error Message Returned! (Status ${r.status})`
            );
          }
        })
        .catch(err => console.error(err));
    },
    generateGraph() {
      this.$router.push({
        name: "multi_graph",
        //name: "log",
        query: {
          selected_graph_line: this.selectedGraphLine,
          "devices[]": this.selectedDevices.map(device => device.device_token)
        }
      });
    }
  }
};
</script>
